import FetchErrorContainer, {
  FetchErrorContainerProps,
} from "client/common/components/errors/FetchErrorContainer";

import Button from "../buttons/Button";
import EmptyResults from "./EmptyResults";

type FetchErrorResultsProps = FetchErrorContainerProps;

const FetchErrorResults = (props: FetchErrorResultsProps) => {
  return (
    <EmptyResults>
      <EmptyResults.Content>
        <FetchErrorContainer {...props} />
      </EmptyResults.Content>
      <EmptyResults.Body>
        <Button onClick={() => window.location.reload()}>Reload Page</Button>
      </EmptyResults.Body>
    </EmptyResults>
  );
};

export default FetchErrorResults;
